import LoadingPage from 'components/Shared/LoadingPage';
import { IAppRoute } from 'interfaces/route';
import * as React from 'react';
import { PureComponent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import authService from 'services/auth';
import { cookieService } from 'services/cookieService';
import userService from 'services/user';

interface IState {
  isAuthenticated: boolean;
  accountsLength: number;
}

interface IProps {
  route: IAppRoute;
  routeProps: RouteComponentProps<any>;
}

export default class AppRouterProtected extends PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { isAuthenticated: false, accountsLength: null };
  }

  componentDidMount() {
    authService.isAuthenticated().subscribe(isAuthenticated => this.setState({ isAuthenticated }));
    userService.getAccounts().subscribe(accounts => this.setState({ accountsLength: accounts.length }));
  }

  render() {
    const { isAuthenticated, accountsLength: accountsNumber } = this.state;
    const { route, routeProps, children } = this.props;

    const alreadyRedirected = Boolean(cookieService.getCookie('isRedirected'));

    if (!isAuthenticated || (!alreadyRedirected && accountsNumber > 1)) {
      return <LoadingPage />;
    }

    return <route.component {...routeProps}>{children}</route.component>;
  }
}
